<template>
  <calm-page extra-class="billing" :title="$t('menu.billing')">
    <!-- ═══════════════ SEARCH BAR ═══════════════ -->
    <calm-filter-bar
      :search-label="$t('search')"
      :show-reset="false"
      @search="listData(searchParams)"
    >
      <calm-field :label="$t('lmg.trans_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker calm-cal"
          v-model="searchParams.startDate"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.trans_date')">
        <flat-picker
          slot-scope="{ focus, blur }"
          @on-open="focus"
          @on-close="blur"
          :config="{ allowInput: true }"
          class="form-control datepicker calm-cal"
          v-model="searchParams.endDate"
        >
        </flat-picker>
      </calm-field>

      <calm-field :label="$t('lmg.paid_status')">
        <el-select
          v-model="searchParams.paid"
          :placeholder="$t('lmg.paid_status')"
        >
          <el-option
            v-for="option in paidStatus"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </calm-field>

      <calm-field :label="$t('lmg.sort')">
        <el-select
          v-model="searchParams.sort"
          :placeholder="$t('lmg.sort')"
        >
          <el-option
            v-for="option in sort"
            :key="option.ID"
            :label="option.Name"
            :value="option.ID"
          >
          </el-option>
        </el-select>
      </calm-field>

      <calm-field :label="$t('lmg.policy_number')">
        <base-input v-model="searchParams.policyNumber"
            :placeholder="$t('lmg.policy_number')">
        </base-input>
      </calm-field>
    </calm-filter-bar>

    <!-- ═══════════════ TABLE (skin the existing el-table, §11) ═══════════════ -->
    <calm-table
      :total="total"
      :from="from"
      :to="to"
      :per-page.sync="pagination.perPage"
      :current-page.sync="pagination.currentPage"
      :per-page-options="pagination.perPageOptions"
      :per-page-label="$t('per_page') !== 'per_page' ? $t('per_page') : 'ต่อหน้า'"
      :count-label="$t('data')"
      :to-label="$t('to')"
      :of-label="$t('of')"
      :empty-title="$t('no_data') !== 'no_data' ? $t('no_data') : 'ไม่พบข้อมูล'"
    >
      <template slot="toolbar">
        <input
          v-model="searchQuery"
          type="text"
          class="ed"
          :placeholder="$t('search')"
        />
      </template>

            <el-table
              :data="queriedData"
              row-key="id"
              header-row-class-name="thead-light"
              @sort-change="sortChange"
              @selection-change="selectionChange"
            >
              <!-- <el-table-column :label="$t(`lmg.recorder`)">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.RecordPersonFName }} {{ row.RecordPersonLName }}
                </div>
              </el-table-column> -->

              <el-table-column :label="$t(`lmg.person`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.OwnerFName }} {{ row.OwnerLName }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.customer`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.CustomerFname }} {{ row.CustomerLname }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.policy_number`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.PolicyNumber }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.amount`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  <!-- {{ row.Amount }} -->
                  {{ FormatCurrency(row.PayAmount) }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.paid_status`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  <span
                    class="billing__pill"
                    :class="row.Paid == 1 ? 'billing__pill--paid' : 'billing__pill--awaiting'"
                  >
                    {{ getPaidStatus(row.Paid) }}
                  </span>
                </div>
              </el-table-column>

              <el-table-column :label="$t(`lmg.due_date`)" min-width="200">
                <div slot-scope="{ row }" class="d-flex">
                  {{ row.DueDate }}
                </div>
              </el-table-column>

              <el-table-column :label="$t(`actions`)" min-width="200">
                <div slot-scope="{ row }" class="billing__rowact">

                   <calm-button
                    @click="handleTransactionDetail(row)"
                    variant="ghost"
                    size="sm"
                    icon-only
                    :title="$t('menu.trans')"
                  >
                    <i class="fa fa-list"></i>
                  </calm-button>


                   <calm-button
                      @click="handlePayment( row)"
                      variant="primary"
                      size="sm"
                      icon-only
                      v-if="row.Paid == 2"
                    :title="$t('lmg.payment')"
                    >
                      <i class="fas fa-dollar-sign"></i>

                    </calm-button>

                </div>
              </el-table-column>
            </el-table>
    </calm-table>



    <modal
      :show.sync="showDetailModal"
      modal-classes="modal-secondary modal-lg"
      custom-class="calm__dialog calm"
    >
      <h1>{{ $t("lmg.trans_detail") }} : {{ detail.ID }}</h1>
      <!-- recorder owner person customer -->
      <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.sale_date')"
            :value="detail.SaleDate"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.recorder')"
            :value="detail.RecordPersonFName + '  ' + detail.RecordPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.owner_person')"
            :value="detail.OwnerPersonFName + '  ' + detail.OwnerPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.customer')"
            :value="detail.CustomerFname + '  ' + detail.CustomerLname"
          ></base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.insure')"
            :value="detail.InsuranceShowName"
          ></base-input>
        </div>

 




        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_amount')"
            :value="detail.Amount"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.summary_amount')"
            :value="detail.AmountAll"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.comm_incentive')"
            :value="detail.Incentive"
            :name="$t('lmg.comm_incentive')"
            rules="required|numeric"
          >
          </base-input>
        </div>

        <div class="col-lg-2">
              <base-input
                :label="$t('lmg.moreDiscount')"
                :value="detail.moreDiscount"
                :name="$t('lmg.moreDiscount')"
              >
              </base-input>
            </div>
        </div>

        <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.comm_amount')"
            :value="detail.CommissionAmount"
          ></base-input>
        </div>

        

       

        <!-- <div class="col-lg-3">
          <base-input
            :label="$t('lmg.commission_percent')"
            :value="detail.CommissionPercent"
          ></base-input>
        </div> -->

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.net_amount')"
            :value="detail.NetAmount"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.tax_amount')"
            :value="detail.TaxAmount"
          ></base-input>
        </div>





        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.pay_amount')"
            :value="detail.PayAmount"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_amount')"
            :value="detail.InitialPayment"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_comm')"
            :value="detail.InitialCom"
          ></base-input>
        </div>


      </div>

      <div class="row">
        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.ttype')"
            :value="detail.TransactionTypeName"
          ></base-input>
        </div>

        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.comm')"
            :value="detail.ComProfileName"
          ></base-input>
        </div>
      </div>
      <hr />

      <!-- --------------------------------------------------------------------- -->

      <div class="row">
        <!-- <div class="col-lg-4">
              <base-input
                :label="$t('lmg.insure_year')"
                :value="detail.InsuranceYear"
                rules="required"
                :name="$t('lmg.insure_year')"
              ></base-input>
            </div>

            <div class="col-lg-4">
              <base-input
                :label="$t('lmg.trans_detail')"
                :value="detail.Detail"
                rules="required"
                :name="$t('lmg.trans_detail')"
              ></base-input>
            </div> -->

        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.policy_number')"
            :name="$t('lmg.policy_number')"
            rules="required"
            :value="detail.PolicyNumber"
          ></base-input>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 1">
        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.car_model')"
            :name="$t('lmg.car_model')"
            rules="required"
            :value="detail.CarModel"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.chassis_number')"
            :name="$t('lmg.chassis_number')"
            rules="required"
            :value="detail.ChassisNumber"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.license_plate')"
            :name="$t('lmg.license_plate')"
            rules="required"
            :value="detail.LicencePlate"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.car_year')"
            :name="$t('lmg.car_year')"
            rules="required"
            :value="detail.CarRegisterYear"
          ></base-input>
        </div>

        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 2">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_plan')"
            :name="$t('lmg.insure_plan')"
            rules="required"
            :value="detail.InsurancePlan"
          ></base-input>
        </div>

        <div class="col-lg-1">
          <base-input
            :label="$t('lmg.age')"
            :name="$t('lmg.age')"
            rules="required"
            :value="detail.CustomerAge"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.detail')"
            :name="$t('lmg.detail')"
            rules="required"
            :value="detail.Detail"
          ></base-input>
        </div>

        <div class="col-lg-2">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <!-- LINE 5 - dataType 3 -->
      <div class="row" v-if="detail.TransactionDataType == 3">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.billing_address')"
            :name="$t('lmg.billing_address')"
            rules="required"
            :value="detail.BuildingAddress"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.code_disaster')"
            :name="$t('lmg.code_disaster')"
            rules="required"
            :value="detail.CodeDisaster"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <!-- LINE 5 - dataType 4 -->
      <div class="row" v-if="detail.TransactionDataType == 4">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.car_model')"
            :name="$t('lmg.car_model')"
            rules="required"
            :value="detail.CarModel"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.chassis_number')"
            :name="$t('lmg.chassis_number')"
            rules="required"
            :value="detail.ChassisNumber"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.license_plate')"
            :name="$t('lmg.license_plate')"
            rules="required"
            :value="detail.LicencePlate"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
        <div class="col-lg-12">
          <base-input
            :label="$t('lmg.insurance_scope')"
            :name="$t('lmg.insurance_scope')"
            rules="required"
            :value="detail.InsuranceScope"
          ></base-input>
        </div>
      </div>

      <div class="row" v-if="detail.TransactionDataType == 5">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_type')"
            :name="$t('lmg.insure_type')"
            rules="required"
            :value="detail.InsuranceTypeDesc"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_plan')"
            :name="$t('lmg.insure_plan')"
            rules="required"
            :value="detail.InsurancePlan"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.note')"
            :name="$t('lmg.note')"
            rules="required"
            :value="detail.Detail"
          ></base-input>
        </div>

        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.insure_sum')"
            :name="$t('lmg.insure_sum')"
            rules="required"
            :value="detail.SumInsured"
          ></base-input>
        </div>
      </div>

      <!-- start , end  note -->
      <div class="row">
        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.protection_date')"
            :value="detail.StartDate + '  ' + $t('to') + '  ' + detail.EndDate"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('status')"
            value="สำเร็จ"
            v-if="detail.Status == 1"
          ></base-input>
          <base-input
            :label="$t('status')"
            value="กำลังดำเนินการ"
            v-if="detail.Status == 2"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_date')"
            :value="detail.CreatedAt"
          ></base-input>
        </div>
      </div>

      <!-- สถานะการเงิน / cash not clear -->
      <!-- created date / status -->
      <div class="row">
        <div class="col-lg-6">
          <base-input :label="$t('lmg.note')" :value="detail.Note"></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่มีเงินสดค้างที่พนักงาน"
            v-if="detail.CashClear == 1"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="มีเงินสดค้าง"
            v-if="detail.CashClear == 2"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่ใช้เงินสด ไม่มีเงินค้าง"
            v-if="detail.CashClear == 3"
          ></base-input>
        </div>
        <div class="col-lg-3" v-if="detail.CashClear == 2">
          <base-input
            :label="$t('lmg.cash_clear_amount')"
            :value="detail.CashNotClearAmount"
          ></base-input>
        </div>
      </div>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>



    <modal :show.sync="showAddModal" modal-classes="modal-secondary" custom-class="calm__dialog calm">

      <h1>{{ $t("lmg.payment_create") }}</h1>
      <form class="new-event--form" @submit.prevent="saveEvent">

        <base-input
          :label="$t('lmg.trans_payment_amount')"
          :value="md.amount"
          readonly
        ></base-input>

        <base-input
          :label="$t('lmg.moreDiscount')"
          v-model="md.moreDiscount"
          readonly
        ></base-input>

        <base-input
          :label="$t('lmg.billing_paid_via')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select
            v-model="md.paidVia"
            :placeholder="$t('lmg.billing_paid_via')"
          >
            <el-option
              v-for="option in paidType"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
        <base-input
          :label="$t('lmg.billing_note')"
          v-model="md.Note"
        ></base-input>

        <base-input
          :label="$t('lmg.bank')"
          input-classes="form-control-alternative new-event--title"
        >
          <el-select v-model="md.bankID" :placeholder="$t('lmg.bank')">
            <el-option
              v-for="option in tableBank"
              :key="option.ID"
              :label="option.Name"
              :value="option.ID"
            >
            </el-option>
          </el-select>
        </base-input>
        <form>
          <base-input
            :label="$t('lmg.paid_file')"
            input-classes="form-control-alternative new-event--title"
          >
            <file-input @change="filesChange"></file-input>
          </base-input>
        </form>
        <!-- <base-input :label="$t('billing.note')" v-model="md.note"></base-input>
        <base-input :label="$t('billing.note')" v-model="md.note"></base-input> -->

        <input type="hidden" class="new-event--start" />
        <input type="hidden" class="new-event--end" />
      </form>

      <template slot="footer">
        <button
          type="submit"
          class="btn btn-md btn-primary"
          @click="handleUpdate()"
        >
          {{ $t("save") }}
        </button>
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showAddModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>

       <!-- ------------------------  Modal Detail  ------------------------ -->
    <modal
      :show.sync="showTransactionDetailModal"
      modal-classes="modal-secondary modal-lg"
      custom-class="calm__dialog calm"
    >
     <h1>{{ $t("lmg.trans_detail") }} : {{ trans.ID }}</h1>
      <!-- recorder owner person customer -->
      <div class="row">
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.recorder')"
            :value="trans.RecordPersonFName + '  ' + trans.RecordPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.owner_person')"
            :value="trans.OwnerPersonFName + '  ' + trans.OwnerPersonLName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.customer')"
            :value="trans.CustomerFname + '  ' + trans.CustomerLname"
          ></base-input>
        </div>
      </div>

      <!-- ttype comprofile amount -->
      <div class="row">
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.amount')"
            :value="trans.Amount"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.ttype')"
            :value="trans.TransactionTypeName"
          ></base-input>
        </div>
        <div class="col-lg-4">
          <base-input
            :label="$t('lmg.comm')"
            :value="trans.ComProfileName"
          ></base-input>
        </div>
      </div>

      <!-- initial com  payment pay  , amount-->
      <!-- policy number , licentpage -->
      <div class="row">
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_comm')"
            :value="trans.InitialCom"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.payment_amount')"
            :value="trans.InitialPayment"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.policy_number')"
            :value="trans.PolicyNumber"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.license_plate')"
            :value="trans.LicencePlate"
          ></base-input>
        </div>
      </div>

      <!-- start , end  note -->
      <div class="row">
        <div class="col-lg-6">
          <base-input
            :label="$t('lmg.protection_date')"
            :value="trans.StartDate + ' - ' + trans.EndDate"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('status')"
            value="สำเร็จ"
            v-if="trans.Status == 1"
          ></base-input>
          <base-input
            :label="$t('status')"
            value="กำลังดำเนินการ"
            v-if="trans.Status == 2"
          ></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.trans_date')"
            :value="trans.CreatedAt"
          ></base-input>
        </div>
      </div>

      <!-- สถานะการเงิน / cash not clear -->
      <!-- created date / status -->
      <div class="row">
        <div class="col-lg-6">
          <base-input :label="$t('lmg.note')" :value="trans.Note"></base-input>
        </div>
        <div class="col-lg-3">
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่มีเงินสดค้างที่พนักงาน"
            v-if="trans.CashClear == 1"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="มีเงินสดค้าง"
            v-if="trans.CashClear == 2"
          ></base-input>
          <base-input
            :label="$t('lmg.cash_clear')"
            value="ไม่ใช้เงินสด ไม่มีเงินค้าง"
            v-if="trans.CashClear == 3"
          ></base-input>
        </div>
        <div class="col-lg-3" v-if="trans.CashClear == 2">
          <base-input
            :label="$t('lmg.cash_clear_amount')"
            :value="trans.CashNotClearAmount"
          ></base-input>
        </div>
      </div>

      <template slot="footer">
        <button
          type="button"
          class="btn btn-md btn-link ml-auto"
          @click="showTransactionDetailModal = false"
        >
          {{ $t("close") }}
        </button>
      </template>
    </modal>
  </calm-page>
</template>
<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/BillingPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import FileInput from "@/components/Inputs/FileInput";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  mixins: [clientPaginationMixin],
  components: {
    flatPicker,
    BasePagination,
    RouteBreadCrumb,
    FileInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn
  },
  computed: {
    ...mapGetters({
      tableDataOrg: "Billing/getData",
      tableBank: "Bank/getData",
      tableTrans: "Transaction/getData",
      tablePayment: "Payment/getData"
    }),
    trans : function(){
      if (this.tableTrans.length > 0)
      return this.tableTrans[0]
      else return {}

    },
    detail : function(){
      if (this.tableTrans.length > 0)
      return this.tableTrans[0]
      else return {}

    },
    tableData: function() {
      // console.log(this.$route.query.id);
      // if (this.$route.query.id != null) {
      //   return this.tableDataOrg.filter((m) => {
      //     return m.EnterpriseID == "" + this.$route.query.id;
      //   });
      // }

      return this.tableDataOrg;
    }
  },
  data() {
    return {
      propsToSearch: ["Name", "AcountNumber"],
      selectedRows: [],
      showAddModal: false,
      showDetailModal: false,
      showTransactionDetailModal : false,
      searchParams: {
        startDate: "",
        endDate: "",
        sort: 1, //1=DESC
        tID: 0, // TransactionID
        paid: 0, // 0 = all , 1= จ่ายแล้ว 2 = ยังไม่ได้จ่าย
        policyNumber:"",
      },
      // trans: {
      //   ownerPersonID: "",
      //   comProfileID: "",
      //   amount: "",
      //   initialCom: "",
      //   initialPayment: "",
      //   initialPaymentVia: "",
      //   paymentBankID: "",
      //   policyNumber: "",
      //   licencePlate: "",
      //   startDate: "",
      //   endDate: "",
      //   customerID: "",
      //   customerCardNumber: "",
      //   customerFname: "",
      //   customerLname: "",
      //   customerPrefix: "",
      //   customerGender: "",
      //   customerDateOfBirth: "",
      //   customerTel: "",
      //   customerEmail: "",
      //   note: "",
      //   nBilling: "",
      //   tfimg: ""
      // },
      md: {
        billID: "",
        paidVia: 1,
        Note: "",
        billFile: "",
        bankID: "",
        amount: "",
        moreDiscount: "",
      },

      paidType: [
        { ID: 1, Name: "เงินสด" },
        { ID: 2, Name: "เช็ค" },
        { ID: 3, Name: "โอนเงิน" }
      ],
      paidStatus: [
        { ID: 0, Name: "All" },
        { ID: 1, Name: "จ่ายแล้ว" },
        { ID: 2, Name: "ยังไม่จ่าย" }
      ],
      sort: [
        { ID: 0, Name: "วันที่ล่าสุด" },
        { ID: 1, Name: "วันที่เริ่มต้น" }
      ]
    };
  },
  async mounted() {
    await this.listBank();

    this.md.bankID = this.tableBank[0].ID;

    // var today = new Date();
    // let yy = today.getFullYear()
    // let mm = today.getMonth()
    // let dd = today.getDate()
    // this.searchParams.startDate = yy + "-" + (mm > 9 ? '' : '0' ) + mm + "-" + (dd > 9 ? '' : '0' ) + dd 
    // this.searchParams.endDate = yy + "-" + ( (mm + 1) > 9 ? '' : '0' ) + (mm+1) + "-" + (dd > 9 ? '' : '0' ) + dd 

    this.searchParams.startDate =  this.getStartDate()
    this.searchParams.endDate = this.getEndDate()

    await this.listData(this.searchParams);
  },
  methods: {
    ...mapActions({
      createData: "Billing/createData",
      listData: "Billing/listData",
      listBank: "Bank/listData",
      listTransaction: "Transaction/listData",
      listPayment: "Payment/listData",
    }),
    getPaidStatus(t) {
      let s =  this.paidStatus.filter(f => {
        return f.ID == t;
      });

      return s[0].Name
    },
    handleTransactionDetail(row){
      // this.showTransactionDetailModal = true;
      this.showDetailModal = true
      this.listTransaction({tID: row.TID})
    },
    handlePayment(row) {
      this.showAddModal = true;
      this.md.ID = 0;
      this.md.billID = row.ID;
      this.md.paidVia = 1;
      this.md.Note = "";
      // this.md.amount = row.Amount;
      this.md.amount = row.PayAmount;
      this.md.moreDiscount = row.moreDiscount;
    },
    handleUpdate() {
      this.showAddModal = false;

        let formData = new FormData();
        formData.append("billID", this.md.billID);
        formData.append("paidVia", this.md.paidVia);
        formData.append("note", this.md.Note);
        formData.append("tfimg", this.md.billfile);
        formData.append("bankID", this.md.bankID);
        formData.append("moreDiscount", this.md.moreDiscount);

        this.createData(formData)
          .then(resp => {
            this.listData(this.searchParams);
            swal.fire({
              title: this.$t("create_success"),
              text: ``,
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              buttonsStyling: false
            });
          })
          .catch(err => {
            swal.fire({
              title: this.$t(err.response.data.Msg),
              text: this.getErrorText(err.response.data),
              icon: "error",
              confirmButtonClass: "btn btn-danger btn-fill",
              buttonsStyling: false
            });
          });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    filesChange(files) {
      this.md.billfile = files[0];
    }
  }
};
</script>
<style scoped>
/* Billing list — Calm skin. Namespaced under .billing so nothing leaks to
   other pages. The el-table is kept verbatim (§11 "skin, don't rewrite") and
   re-styled only via deep selectors. The detail / payment / transaction-detail
   modals stay on the existing Argon <modal> (custom-class="calm__dialog calm")
   so the file-upload + read-only field mechanics are untouched. */

/* Row-action cell: keep the icon buttons inline. */
.billing__rowact {
  display: inline-flex;
  gap: 6px;
  align-items: center;
}

/* Paid status as a calm presentation pill (no logic change). */
.billing__pill {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 999px;
  font-size: 13px;
  line-height: 1.4;
}
.billing__pill--paid {
  background: var(--c-success-soft, #e6f3ee);
  color: var(--c-success, #38866b);
}
.billing__pill--awaiting {
  background: var(--c-warning-soft, #fdf3e0);
  color: var(--c-warning, #c08527);
}

/* The free-text search box reuses the Kit's .ed input look. */
.billing >>> .ed {
  width: 240px;
  max-width: 100%;
}

/* Skin the existing <el-table> so it reads as a Calm surface without touching
   any column definitions or slots (§11). Deep selectors only. */
.billing >>> .el-table {
  color: var(--c-text, #2c3e50);
  background: transparent;
}
.billing >>> .el-table th,
.billing >>> .el-table .thead-light th {
  background: var(--c-surface-soft, #f4f7fb);
  color: var(--c-text-soft, #5b6b7e);
  font-weight: 600;
  border-bottom: 1px solid var(--c-border, #e3e9f0);
}
.billing >>> .el-table td {
  border-bottom: 1px solid var(--c-border, #eef2f7);
}
.billing >>> .el-table::before {
  background: var(--c-border, #e3e9f0);
}
.billing >>> .el-table__row:hover > td {
  background: var(--c-surface-soft, #f7fafd) !important;
}
</style>
